<p-toast></p-toast>

<div class="p-grid">

  <div *ngIf="!loading" class="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12 p-px-3 p-px-sm-3 p-px-md-3 p-px-lg-3 p-px-xl-3">
    
      <!-- tarjeta información personal -->
        <div class="p-grid datos-card">
          <div class="p-col-12">
            <div class="p-d-flex p-ai-center">
              <i class="pi pi-id-card p-mr-2" style="font-size: 2.2rem"></i>
              <h3>Información personal</h3>
            </div>
            <p class="text-muted">Su información personal será utilizada para generar su certificado, por lo que si requiere realizar algún cambio o existe algún problema, debe solicitarlo.</p>
          </div>
          <div class="p-col-12 p-grid">
            <div class="p-col-12 p-xs-12 p-sm-12 p-md-6 p-lg-4 p-xl-4">
              <span class="text-muted"><small>Nombres</small></span><br>
              <input pInputText type="text" value="{{postulante.nombres}}" readonly>
            </div>
            <div class="p-col-12 p-xs-12 p-sm-12 p-md-6 p-lg-4 p-xl-4">
              <span class="text-muted"><small>Apellidos</small></span><br>
              <input pInputText  type="text" value="{{postulante.paterno}}" readonly>
            </div>
            <div class="p-col-12 p-xs-12 p-sm-12 p-md-6 p-lg-4 p-xl-4">
              <span class="text-muted"><small>Run</small></span><br>
              <input pInputText type="text" value="{{postulante.run + '-' +postulante.dv}}" readonly>
            </div>
            <div class="p-col-12 p-xs-12 p-sm-12 p-md-6 p-lg-4 p-xl-4">
              <span class="text-muted"><small>Sexo</small></span><br>
              <input pInputText  type="text" value="{{postulante.id_sexo == 1 ? 'MASCULINO' : 'FEMENINO'}}" readonly>
            </div>
            <div class="p-col-12 p-xs-12 p-sm-12 p-md-6 p-lg-4 p-xl-4">
              <span class="text-muted"><small>Fecha de nacimiento</small></span><br>
              <input pInputText  type="text" value="{{postulante.fechaNacimiento | date: 'dd/MM/yyyy' : 'UTC+0' }}" readonly>
            </div>
          </div>
        </div>
  
        <!-- tarjeta información de contacto -->
        <form [formGroup]="formContacto">
          <div class="p-grid datos-card">
            <div class="p-col-12">
              <div class="p-d-flex p-ai-center">
                <i class="pi pi-phone p-mr-2" style="font-size: 2rem"></i>
                <h3>Información de contacto</h3>
              </div>
              <p class="text-muted">Mantenga sus datos de contacto actualizados. El correo electrónico no podrá cambiarse a menos que se solciite.</p>
            </div>
            <div class="p-col-12 p-grid">
              <div class="p-col-12 p-xs-12 p-sm-12 p-md-6 p-lg-4 p-xl-4">
                <span class="text-muted"><small>Correo electrónico</small></span><br>
                <input pInputText type="text" value="{{postulante.correo}}" readonly>
              </div>
              <div class="p-col-12 p-xs-12 p-sm-12 p-md-6 p-lg-4 p-xl-4">
                <span class="text-muted"><small>Teléfono</small></span><br>
                <input *ngIf="isEditing || formContacto.get('telefono').value != null" pInputText type="text" digitOnly [maxLength]="9"
                (keypress)="regExpInput('^([0-9])',$event)" [className]="isEditing ? 'input-editing' : ''" formControlName="telefono" [readonly]="readonly">
                <span *ngIf="!isEditing && formContacto.get('telefono').value == null">SIN INFORMACIÓN</span>
                <div *ngIf="formContacto.get('telefono').invalid && (formContacto.get('telefono').dirty || formContacto.get('telefono').touched)">
                  <span class="p-error" *ngIf="formContacto.get('telefono').hasError('maxlength')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Límite de caracteres excedido.</small>
                  </span>
                  <span class="p-error" *ngIf="formContacto.get('telefono').hasError('minlength')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">El número debe contener los 9 dígitos. Ej: 912345678</small>
                  </span>
                  <span class="p-error" *ngIf="formContacto.get('telefono').hasError('pattern') && (formContacto.get('telefono').value.length <= 9)">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Debe ingresar solo números.</small>
                  </span>
                </div>
              </div>
              <div *ngIf="formContacto.get('id_region').value" class="p-col-3">
                <span class="text-muted"><small>Región</small></span><br>
                <p-dropdown 
                  [options]="regiones" 
                  formControlName="id_region" 
                  optionLabel="label" 
                  optionValue="value"
                  [readonly]="readonly"
                  (onChange)="cargarComunas()"
                  [className]="isEditing ? 'dropdown-editing' : ''"
                >
                </p-dropdown>
                <div *ngIf="formContacto.get('id_region').invalid && (formContacto.get('id_region').dirty || formContacto.get('id_region').touched)">
                  <span class="p-error" *ngIf="formContacto.get('id_region').hasError('required')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Debe seleccionar su región</small>
                  </span>
                </div>
              </div>
              <div *ngIf="formContacto.get('id_region').value" class="p-col-12 p-xs-12 p-sm-12 p-md-6 p-lg-4 p-xl-4">
                <span class="text-muted"><small>Comuna</small></span><br>
                <p-dropdown 
                  [options]="comunas" 
                  formControlName="id_comuna" 
                  optionLabel="label" 
                  optionValue="value"
                  [readonly]="readonly"
                  [className]="isEditing ? 'dropdown-editing' : ''"
                >
                </p-dropdown>
                <div *ngIf="formContacto.get('id_region').valid && formContacto.get('id_comuna').invalid && (formContacto.get('id_comuna').dirty || formContacto.get('id_comuna').touched)">
                  <span class="p-error" *ngIf="formContacto.get('id_comuna').hasError('required')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Debe seleccionar su comuna</small>
                  </span>
                </div>
              </div>
              <div class="p-col-12 p-xs-12 p-sm-12 p-md-6 p-lg-4 p-xl-4">
                <span class="text-muted"><small>Dirección</small></span><br>
                <input *ngIf="isEditing || formContacto.get('direccion').value != ''" (keypress)="regExpInput('^([A-Za-z0-9 ])',$event)" pInputText type="text" [maxLength]="100" [className]="isEditing ? 'input-editing' : ''" formControlName="direccion" [readonly]="readonly">
                <span *ngIf="!isEditing && formContacto.get('direccion').value == ''">SIN INFORMACIÓN</span>
                <div *ngIf="formContacto.get('direccion').invalid && (formContacto.get('direccion').dirty || formContacto.get('direccion').touched)">
                  <span class="p-error" *ngIf="formContacto.get('direccion').hasError('maxlength')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Límite de caracteres excedido.</small>
                  </span>
                </div>
              </div>
              <div class="p-col-12 p-xs-12 p-sm-12 p-md-6 p-lg-4 p-xl-4">
                <span class="text-muted"><small>Ocupación</small></span><br>
                <input (keypress)="regExpInput('^([A-Za-z ])',$event)" pInputText type="text" [maxLength]="50" [className]="isEditing ? 'input-editing' : ''" formControlName="ocupacion" [readonly]="readonly">
                <div *ngIf="formContacto.get('ocupacion').invalid && (formContacto.get('ocupacion').dirty || formContacto.get('ocupacion').touched)">
                  <span class="p-error" *ngIf="formContacto.get('ocupacion').hasError('required')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Debe indicar su ocupación o profesión.</small>
                  </span>
                  <span class="p-error" *ngIf="formContacto.get('ocupacion').hasError('maxlength')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Límite de caracteres excedido.</small>
                  </span>
                </div>
              </div>
              <div class="p-col-12 p-xs-12 p-sm-12 p-md-6 p-lg-4 p-xl-4">
                <span class="text-muted"><small>Empresa</small></span><br>
                <input *ngIf="isEditing || formContacto.get('empresa').value != ''" (keypress)="regExpInput('^([A-Za-z ])',$event)" pInputText type="text" [maxLength]="50" [className]="isEditing ? 'input-editing' : ''" formControlName="empresa" [readonly]="readonly">
                <span *ngIf="!isEditing && formContacto.get('empresa').value == ''">SIN INFORMACIÓN</span>
                <div *ngIf="formContacto.get('empresa').invalid && (formContacto.get('empresa').dirty || formContacto.get('empresa').touched)">
                  <span class="p-error" *ngIf="formContacto.get('empresa').hasError('maxlength')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Límite de caracteres excedido.</small>
                  </span>
                </div>
              </div>
              <div class="p-col-12 p-text-right">
                <button *ngIf="!isEditing" (click)="setEditing()" pButton class="btn-secondary" icon="pi pi-user-edit" label="Modificar datos de contacto"></button>
                <button *ngIf="isEditing && !isSaving" (click)="cancelEditing()" pButton class="btn-primary-outline p-mr-2" icon="pi pi-times" label="Cancelar"></button>
                <button *ngIf="isEditing" (click)="saveEditing()" pButton class="btn-primary" icon="pi pi-save" [disabled]="formContacto.invalid || isSaving" [loading]="isSaving" label="Guardar cambios"></button>
              </div>
            </div>
          </div>
        </form>
  </div>

  <div *ngIf="loading"  class="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12 p-px-3 p-px-sm-3 p-px-md-3 p-px-lg-3 p-px-xl-3">
    <div class="p-grid datos-card datagrid__row" *ngFor="let datos of [1,2]">
      <div class="p-col-12 p-lg-8">
        <div class="p-d-flex p-flex-column">
          <div class="p-mb-2"><p-skeleton width="60%" height="1.8rem"></p-skeleton></div>
          <div class="p-mb-3"><p-skeleton width="90%" height="1.8rem"></p-skeleton></div>
        </div>
      </div>
      <div class="p-col-12 p-grid">
        <div class="p-col-12 p-xs-12 p-sm-12 p-md-6 p-lg-4 p-xl-4 p-mb-2">
          <p-skeleton width="100%" height="2rem"></p-skeleton>
        </div>
        <div class="p-col-12 p-xs-12 p-sm-12 p-md-6 p-lg-4 p-xl-4 p-mb-2">
          <p-skeleton width="100%" height="2rem"></p-skeleton>
        </div>
        <div class="p-col-12 p-xs-12 p-sm-12 p-md-6 p-lg-4 p-xl-4 p-mb-2">
          <p-skeleton width="100%" height="2rem"></p-skeleton>
        </div>
        <div class="p-col-12 p-xs-12 p-sm-12 p-md-6 p-lg-4 p-xl-4 p-mb-2">
          <p-skeleton width="100%" height="2rem"></p-skeleton>
        </div>
        <div class="p-col-12 p-xs-12 p-sm-12 p-md-6 p-lg-4 p-xl-4 p-mb-2">
          <p-skeleton width="100%" height="2rem"></p-skeleton>
        </div>
      </div>
    </div>
  </div>
</div>